<template>
    <div class="d-flex justify-content-center">
        <h1>Your kitchens</h1>
    </div>

    <div class="d-flex justify-content-end">
        <div class="btn btn-success" @click="toggleModal">Create a Kitchen</div>
    </div>

    <kitchens />

    <!-- The modal -->
    <div class="modal" v-show="store.showKitchenCreateModal">

        <!-- Modal content -->
        <div class="modal-content">
            <span class="close" @click="toggleModal">&times;</span>
            <createUpdateKitchen/>
        </div>

    </div>





</template>


<script setup>

import Kitchens  from './KitchensList.vue';
import createUpdateKitchen from './CreateUpdateKitchen.vue';

import { useKitchenStore } from '@/stores/kitchen';

const store = useKitchenStore();

function toggleModal(){
    store.toggleKitchenCreateModal();

    store.changeKitchen({places: []});
}

</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 100%;
  max-width: 1000px; /* Adjust the max-width as needed */
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>